
import _ from 'lodash'
import {userRemarkList} from "@/api/custom.js"
const UserRemark = {
    state: {
        remarkList: [],

    },
    mutations: {
        SET_REMARK_LIST: (state, payload) => {
            state.remarkList = payload
        },
        UPSERT_REMARK: (state, payload) => {
            if (!payload) return
            const keyid = payload.toHxId || payload.toUserId || payload.fromHxId
            if (!keyid) return
            state.remarkList = {
                ...(state.remarkList || {}),
                [keyid]: payload
            }
        }
    },
    actions: {
        // 获取用户备注列表
        getUserRemarkList: async ({ commit },myId) => {
            try {
                const res = await userRemarkList(myId)
                const rows = res.rows || res.data || []
                
                let remarksMap = {}
                if(rows&&rows.length){
                  for(let i=0;i<rows.length;i++){
                    let remark = rows[i]
                    const keyid = remark.toHxId || remark.toUserId || (remark.fromHxId == myId ? remark.toHxId : remark.fromHxId)
                    if (!keyid) continue
                    const oldRemark = remarksMap[keyid]
                    const isMine = remark.fromHxId == myId
                    const oldIsMine = oldRemark && oldRemark.fromHxId == myId
                    if (!oldRemark || (isMine && !oldIsMine)) {
                      remarksMap[keyid] = remark
                    }
                  }
                }
                console.log("%c Line:27 🧀拿到用户备注列表 remarksMap", "color:#e41a6a", remarksMap);
                if(rows){
                  commit('SET_REMARK_LIST', remarksMap)
                }else{
                  commit('SET_REMARK_LIST', {})
                }
                
            } catch (error) {
              commit('SET_REMARK_LIST', {})
            }
        }
    }
}

export default UserRemark
